import * as React from "react";

export const IconRefresh = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.3667 1.95833C10.1583 0.75 8.5 0 6.65833 0C2.975 0 0 2.98333 0 6.66667C0 10.35 2.975 13.3333 6.65833 13.3333C9.76667 13.3333 12.3583 11.2083 13.1 8.33333H11.3667C10.6833 10.275 8.83333 11.6667 6.65833 11.6667C3.9 11.6667 1.65833 9.425 1.65833 6.66667C1.65833 3.90833 3.9 1.66667 6.65833 1.66667C8.04167 1.66667 9.275 2.24167 10.175 3.15L7.49167 5.83333L13.325 5.83333L13.325 0L11.3667 1.95833Z"
      fill="#767B7E"
    />
  </svg>
);
